import { render, staticRenderFns } from "./add-case.vue?vue&type=template&id=091c5cb8&scoped=true&"
import script from "./add-case.vue?vue&type=script&lang=js&"
export * from "./add-case.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "091c5cb8",
  null
  
)

export default component.exports